<template>
  <div class="popup-info_momentum">
    <div class="popup-info__area section">
      <div class="label">
        {{ $t("labels.description") }}
      </div>
      <formatted-text v-if="item.description" :value="item.description" />
      <p v-else>
        {{ $t("errors.noDescription") }}
      </p>
    </div>
    <div class="popup-info__area section popup-info_momentum__change">
      <div class="label">
        {{
          $t("labels.updateXEveryRound", {
            title: element.title,
            interval: ordinalInterval
          })
        }}
      </div>

      <strong style="font-size: 1.125rem; color: var(--color-text-medium)">{{
        $n(value, "displaySign")
      }}</strong>&thinsp;{{ element.unit }}
      <!-- <div style="min-height: 15rem">
        <input-curve
          style="width: 15rem"
          :value="elementValue"
          :x-min="element.minValue"
          :x-max="element.maxValue"
          :point-list="curvePoints"
          :type="curveType"
          :type-editable="false"
          :curve-editable="false"
          :formula="momentum.formula"
        />
      </div> -->
    </div>
    <div class="popup-info__area section popup-info_momentum__interval">
      <div class="label">
        {{ $t("labels.interval") }}
      </div>
      <span v-if="item.interval === 0">{{ $t("labels.everyRound") }}</span>
      <span v-if="item.interval != 0">{{
        $t("labels.everyXRound", [item.interval])
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useTargetStore } from "../target/targets.store";
import { getOrdinalNumber } from "@/i18n";
import { useSimulationViewStore } from "@editor/views/simulation/simulationView.store";
import { evaluateRelation } from "../relation/Relation";
import { useResourceStore } from "../resource/resources.store";

import FormattedText from "@core/ui/FormattedText.vue";

import type { MomentumItem } from "./MomentumItem";
import { toUid } from "@/helpers/utility/Id";

const props = defineProps<{
  item: MomentumItem;
  round?: object;
}>();

const simulationView = useSimulationViewStore();
const targetStore = useTargetStore();
const resourceStore = useResourceStore();

const momentum = computed(() => {
  return props.item;
});

const items = computed(() => {
  return {
    target: targetStore.items,
    resource: resourceStore.items
  };
});

const element = computed(() => {
  return items.value[momentum.value.elementType][momentum.value?.elementId];
});

const ordinalInterval = computed(() => {
  if (momentum.value.interval < 2) return "";
  return " " + getOrdinalNumber(momentum.value.interval);
});

const elementValue = computed(() => {
  const elementId = momentum.value.elementId;

  const elementUid = toUid(momentum.value.elementType, elementId);

  return Number(
    simulationView.currentRound?.elementValues?.[elementUid]?.value ??
    simulationView.simulation?.startElementValues?.[elementUid]?.value ??
    element.value.value
  );
});

const value = computed(() => {
  return evaluateRelation(momentum.value, elementValue.value);
});
</script>

<style lang="scss">
.popup-info_momentum {
  grid-template-rows: minmax(2rem, 1fr) minmax(2rem, 5rem) minmax(2rem, 5rem);
}
</style>
